import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
// Minimal coordinate presence
const CoordinateGrid = () => <div className="absolute inset-0 w-full h-full opacity-[0.015] pointer-events-none" style={{
  backgroundImage: 'linear-gradient(#F5F5F5 0.5px, transparent 0.5px), linear-gradient(90deg, #F5F5F5 0.5px, transparent 0.5px)',
  backgroundSize: '80px 80px'
}} aria-hidden="true" data-id="element-1652" />;
export function DiagnosticsLanding() {
  return <>
      <Helmet data-id="element-1653">
        <title data-id="element-1654">
          Decodes — One-Time Structural Interpretations | Lazy Monk Labs
        </title>
        <meta name="description" content="Decodes are one-time structural interpretations powered by Decoder. See the underlying pattern of a specific domain." data-id="element-1655" />
        <meta name="robots" content="index, follow" data-id="element-1656" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-1657">
        {/* Navigation */}
        <header data-id="element-1658">
          <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#2B2B2B]" data-id="element-1659">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-1660">
              <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-1661">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXd6KyuddrgAfqwwkkpUrR/Lazy_Monk_Labs_Logo.png" alt="Lazy Monk Labs Logo" className="h-8 w-auto" width="32" height="32" data-id="element-1662" />
                <span className="text-base font-mono tracking-tight text-gray-400" data-id="element-1663">
                  Lazy Monk Labs
                </span>
              </Link>
              <div className="flex items-center gap-8" data-id="element-1664">
                <Link to="/decodes" className="text-sm text-[#F5F5F5] hover:text-gray-400 transition-colors font-medium" data-id="element-1665">
                  Decodes
                </Link>
                <Link to="/decoder" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-1666">
                  Decoder
                </Link>
                <Link to="/careers" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-1667">
                  Careers
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-1668">
                  Contact
                </a>
              </div>
            </div>
          </nav>
        </header>

        <main className="pt-24 pb-16" data-id="element-1669">
          {/* 1. HERO */}
          <section className="relative py-32 md:py-40 px-6 overflow-hidden" data-id="element-1670">
            <CoordinateGrid data-id="element-1671" />
            <div className="relative z-10 max-w-5xl mx-auto space-y-12" data-id="element-1672">
              <div className="space-y-6" data-id="element-1673">
                <h1 className="text-5xl md:text-7xl font-serif leading-none text-[#F5F5F5]" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-1674">
                  Decodes are one-time structural interpretations.
                </h1>

                <p className="text-xl md:text-2xl text-gray-400 font-light leading-relaxed max-w-3xl" data-id="element-1675">
                  A Decode shows you the underlying pattern of a specific domain
                  — using the same engine that powers all Mirrors at Lazy Monk
                  Labs.
                </p>
              </div>

              <div className="pt-8 flex flex-col sm:flex-row gap-4" data-id="element-1676">
                <a href="#available-decodes" className="px-10 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-sm font-medium hover:bg-gray-200 transition-colors text-center" data-id="element-1677">
                  Explore available Decodes
                </a>
                <Link to="/decoder" className="px-10 py-4 border border-[#F5F5F5] text-[#F5F5F5] text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors text-center" data-id="element-1678">
                  Learn about the engine (Decoder)
                </Link>
              </div>
            </div>
          </section>

          {/* 2. WHAT IS A DECODE */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-1679">
            <div className="max-w-4xl mx-auto" data-id="element-1680">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-12" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1681">
                What is a Decode?
              </h2>

              <div className="space-y-8 text-lg text-gray-400 leading-relaxed" data-id="element-1682">
                <p data-id="element-1683">
                  A Decode is a one-time interpretation of your underlying
                  pattern through a specific lens: self, work, relationships, or
                  time.
                </p>

                <div className="space-y-4" data-id="element-1684">
                  <p data-id="element-1685">It does not tell you what to do.</p>
                  <p data-id="element-1686">It does not give advice.</p>
                  <p data-id="element-1687">It does not try to change you.</p>
                </div>

                <p className="text-[#F5F5F5] pt-6 border-t border-[#2B2B2B]" data-id="element-1688">
                  It shows you the structure you are already running.
                </p>

                <div className="pt-6" data-id="element-1689">
                  <p className="text-sm text-gray-600" data-id="element-1690">
                    Think of it as a structural scan, not a test.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 3. WHAT DECODES ARE FOR */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-1691">
            <div className="max-w-4xl mx-auto" data-id="element-1692">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-12" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1693">
                When do people use a Decode?
              </h2>

              <div className="space-y-6 text-base text-gray-400" data-id="element-1694">
                <p data-id="element-1695">• "I want to understand my default operating structure."</p>
                <p data-id="element-1696">• "I want to see my pattern at work."</p>
                <p data-id="element-1697">• "I want to understand a relationship dynamic."</p>
                <p data-id="element-1698">• "I want to understand the phase I'm in."</p>
                <p data-id="element-1699">• "I want clarity before a transition or decision."</p>
              </div>
            </div>
          </section>

          {/* 4. WHAT THIS IS NOT */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-1700">
            <div className="max-w-6xl mx-auto" data-id="element-1701">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-16 text-center" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1702">
                What this is not
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-1703">
                <div className="space-y-4 text-center" data-id="element-1704">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1705">
                    Not Therapy
                  </h3>
                  <p className="text-base text-gray-400 leading-relaxed" data-id="element-1706">
                    This does not work with emotions or stories. It works with
                    structure.
                  </p>
                </div>

                <div className="space-y-4 text-center" data-id="element-1707">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1708">
                    Not Coaching
                  </h3>
                  <p className="text-base text-gray-400 leading-relaxed" data-id="element-1709">
                    This does not guide, motivate, or suggest.
                  </p>
                </div>

                <div className="space-y-4 text-center" data-id="element-1710">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1711">
                    Not a Test
                  </h3>
                  <p className="text-base text-gray-400 leading-relaxed" data-id="element-1712">
                    This is not a questionnaire that scores you.
                  </p>
                </div>
              </div>

              <div className="pt-12 text-center" data-id="element-1713">
                <p className="text-lg text-[#F5F5F5]" data-id="element-1714">
                  A Decode is an interpretation, not an instruction.
                </p>
              </div>
            </div>
          </section>

          {/* 5. HOW DECODES ARE MADE */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-1715">
            <div className="max-w-4xl mx-auto" data-id="element-1716">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-12" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1717">
                How a Decode is generated
              </h2>

              <div className="space-y-12" data-id="element-1718">
                {/* Inputs */}
                <div className="space-y-4" data-id="element-1719">
                  <p className="text-sm font-mono text-gray-600 uppercase tracking-wider" data-id="element-1720">
                    Inputs
                  </p>
                  <div className="space-y-3 text-base text-gray-400" data-id="element-1721">
                    <p data-id="element-1722">• Structural anchors (e.g. birth imprint)</p>
                    <p data-id="element-1723">• Or targeted questions (for some decodes)</p>
                  </div>
                </div>

                {/* Arrow */}
                <div className="flex justify-center" data-id="element-1724">
                  <div className="text-gray-600 text-2xl" data-id="element-1725">↓</div>
                </div>

                {/* Decoder */}
                <div className="space-y-4" data-id="element-1726">
                  <p className="text-sm font-mono text-gray-600 uppercase tracking-wider" data-id="element-1727">
                    Decoder
                  </p>
                  <p className="text-base text-gray-400" data-id="element-1728">
                    • Converts signals into Pattern Code
                  </p>
                </div>

                {/* Arrow */}
                <div className="flex justify-center" data-id="element-1729">
                  <div className="text-gray-600 text-2xl" data-id="element-1730">↓</div>
                </div>

                {/* Decode */}
                <div className="space-y-4" data-id="element-1731">
                  <p className="text-sm font-mono text-gray-600 uppercase tracking-wider" data-id="element-1732">
                    Decode
                  </p>
                  <p className="text-base text-gray-400" data-id="element-1733">
                    • A one-time interpretation of that code through a specific
                    lens
                  </p>
                </div>

                {/* Closing line */}
                <div className="pt-8 border-t border-[#2B2B2B]" data-id="element-1734">
                  <p className="text-sm text-gray-600" data-id="element-1735">
                    Different inputs. Same engine.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 6. AVAILABLE DECODES */}
          <section id="available-decodes" className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-1736">
            <div className="max-w-6xl mx-auto" data-id="element-1737">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-16" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1738">
                Available Decodes
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1739">
                {/* Self Decode */}
                <div className="border border-[#2B2B2B] p-8 space-y-6 bg-[#0A0A0A]" data-id="element-1740">
                  <div className="space-y-3" data-id="element-1741">
                    <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1742">
                      Self Decode
                    </h3>
                    <p className="text-base text-gray-400 leading-relaxed" data-id="element-1743">
                      Your core operating structure across situations.
                    </p>
                  </div>
                  <Link to="/start?product=self" className="block w-full px-6 py-3 border border-[#F5F5F5] text-[#F5F5F5] text-center text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors" data-id="element-1744">
                    Run this Decode
                  </Link>
                </div>

                {/* Work Decode */}
                <div className="border border-[#2B2B2B] p-8 space-y-6 bg-[#0A0A0A]" data-id="element-1745">
                  <div className="space-y-3" data-id="element-1746">
                    <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1747">
                      Work Decode
                    </h3>
                    <p className="text-base text-gray-400 leading-relaxed" data-id="element-1748">
                      How you tend to operate around responsibility, decisions,
                      and pressure.
                    </p>
                  </div>
                  <Link to="/start?product=work" className="block w-full px-6 py-3 border border-[#F5F5F5] text-[#F5F5F5] text-center text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors" data-id="element-1749">
                    Run this Decode
                  </Link>
                </div>

                {/* Relationship Decode */}
                <div className="border border-[#2B2B2B] p-8 space-y-6 bg-[#0A0A0A]" data-id="element-1750">
                  <div className="space-y-3" data-id="element-1751">
                    <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1752">
                      Relationship Decode
                    </h3>
                    <p className="text-base text-gray-400 leading-relaxed" data-id="element-1753">
                      Your default pattern in closeness, distance, and conflict.
                    </p>
                  </div>
                  <Link to="/start?product=relationship" className="block w-full px-6 py-3 border border-[#F5F5F5] text-[#F5F5F5] text-center text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors" data-id="element-1754">
                    Run this Decode
                  </Link>
                </div>

                {/* Child Decode */}
                <div className="border border-[#2B2B2B] p-8 space-y-6 bg-[#0A0A0A]" data-id="element-1755">
                  <div className="space-y-3" data-id="element-1756">
                    <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1757">
                      Child Decode
                    </h3>
                    <p className="text-base text-gray-400 leading-relaxed" data-id="element-1758">
                      How a child adapts to novelty, pressure, and boundaries.
                    </p>
                  </div>
                  <Link to="/start?product=child" className="block w-full px-6 py-3 border border-[#F5F5F5] text-[#F5F5F5] text-center text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors" data-id="element-1759">
                    Run this Decode
                  </Link>
                </div>
              </div>
            </div>
          </section>

          {/* 7. HOW THIS RELATES TO MIRRORS */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-1760">
            <div className="max-w-6xl mx-auto" data-id="element-1761">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5] mb-16 text-center" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1762">
                Decodes and Mirrors
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-1763">
                <div className="space-y-4" data-id="element-1764">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1765">
                    Decodes
                  </h3>
                  <p className="text-base text-gray-400 leading-relaxed" data-id="element-1766">
                    One-time structural interpretations. Good for clarity now.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-1767">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-1768">
                    Mirrors
                  </h3>
                  <p className="text-base text-gray-400 leading-relaxed" data-id="element-1769">
                    Continuous interpretations over time. Good for seeing the
                    pattern in motion.
                  </p>
                </div>
              </div>

              <div className="text-center mb-12" data-id="element-1770">
                <p className="text-lg text-[#F5F5F5]" data-id="element-1771">
                  Same engine. Different time horizons.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1772">
                <Link to="/mirrors/work" className="px-10 py-4 border border-[#F5F5F5] text-[#F5F5F5] text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors text-center" data-id="element-1773">
                  Explore Work Mirror
                </Link>
                <Link to="/" className="px-10 py-4 border border-[#F5F5F5] text-[#F5F5F5] text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors text-center" data-id="element-1774">
                  Back to Home
                </Link>
              </div>
            </div>
          </section>

          {/* 8. QUIET FINAL CTA */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-1775">
            <div className="max-w-4xl mx-auto text-center space-y-12" data-id="element-1776">
              <h2 className="text-3xl md:text-4xl font-serif text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-1777">
                Choose a Decode
              </h2>

              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1778">
                <a href="#available-decodes" className="px-12 py-4 bg-[#F5F5F5] text-[#0A0A0A] text-sm font-medium hover:bg-gray-200 transition-colors" data-id="element-1779">
                  Explore available Decodes
                </a>
                <Link to="/decoder" className="px-12 py-4 border border-[#F5F5F5] text-[#F5F5F5] text-sm font-medium hover:bg-[#F5F5F5] hover:text-[#0A0A0A] transition-colors" data-id="element-1780">
                  Learn about Decoder
                </Link>
              </div>
            </div>
          </section>
        </main>

        {/* Footer */}
        <footer className="py-12 px-6 border-t border-[#2B2B2B]" data-id="element-1781">
          <div className="max-w-6xl mx-auto" data-id="element-1782">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8" data-id="element-1783">
              <div data-id="element-1784">
                <p className="text-sm text-gray-500 font-mono" data-id="element-1785">
                  Lazy Monk Labs
                </p>
                <p className="text-xs text-gray-600 mt-1" data-id="element-1786">
                  Pattern recognition systems
                </p>
              </div>

              <div className="flex gap-8 text-sm text-gray-500" data-id="element-1787">
                <Link to="/decodes" className="hover:text-[#F5F5F5] transition-colors" data-id="element-1788">
                  Decodes
                </Link>
                <Link to="/decoder" className="hover:text-[#F5F5F5] transition-colors" data-id="element-1789">
                  Decoder
                </Link>
                <Link to="/careers" className="hover:text-[#F5F5F5] transition-colors" data-id="element-1790">
                  Careers
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="hover:text-[#F5F5F5] transition-colors" data-id="element-1791">
                  Contact
                </a>
              </div>

              <div className="text-xs text-gray-600 font-mono" data-id="element-1792">
                © {new Date().getFullYear()}
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>;
}